import FpuiInputDropzone from './FpuiInputDropzone'
export default FpuiInputDropzone
